type IFormAction = {
    type: string,
    payload: any
}

const initialState = {
    full_name: null,
    phone: {
        number: null,
        country_code: null
    },
    shipping_address: {
        line1: null,
        line2: null,
        city: null,
        state: null,
        country: null,
        postal_code: null,
    },
    billing_address: {
        line1: null,
        line2: null,
        city: null,
        state: null,
        country: null,
        postal_code: null
    }
}

export const formReducer = (
    state = initialState,
    action: IFormAction) => {
    switch (action.type) {

        case 'ACTION_SETUP_BILLING': {
            return {
                ...state,
                ...action.payload
            }
        }
        case 'ACTION_SETUP_SHIPPING': {
            return {
                ...state,
                shipping_address: {
                    ...action.payload
                }
            }
        }
        default:
            return state;
    }
};